<template>
    <div class="setting-page-content-wrapper chat-theme-settings">
        <div class="page-header">
            <div class="title">{{ $t("message.chatThemeSettings") }}</div>
            <div class="subtitle">{{ $t("settings.chatThemeSettingsSubtitles") }}</div>
        </div>
        <section>
            <FeatureItem
                v-if="isV2Theme"
                v-model="isVersionV2"
                :title="$t('settings.visitorNew')"
                icon=""
                description="You can use the new version of the visitor theme."
            />
            <ChatThemeEditor v-if="isVersionV2" :update-settings="updateSettings" />
            <div v-if="!isVersionV2">
                <FeatureItem
                    style="margin-bottom: 10px"
                    :title="$t('message.theme')"
                    icon="ThemeIcon"
                    v-model="preferredThemeColor"
                    type="select"
                    :options="[
                        { id: 'custom', label: 'Custom Theme' },
                        ...allThemeColors.map((x) => ({ id: x, label: x })).filter((x) => x.id !== 'custom'),
                    ]"
                    :default-select-option-placeholder="$t('message.selectATheme')"
                    :description="$t('settings.themeDescription')"
                    :show-null-select-option="false"
                />
                <a-card v-if="preferredThemeColor === 'custom'" class="card">
                    <a-card-grid style="width: 25%; text-align: center">
                        <div
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('theme.headerColor1A')"
                            class="custom-field-slider"
                        >
                            <label for="themecolor1">{{ $t("theme.headerColor1") }}</label>
                            <a-input id="themecolor1" v-model="themeColor1" class="theme-color-input" type="color" />
                            <a-slider
                                :max="100"
                                :min="0"
                                :step="5"
                                :value="themeColor1A"
                                @change="(value) => (this.themeColor1A = value)"
                            />
                        </div>
                    </a-card-grid>
                    <a-card-grid style="width: 25%; text-align: center">
                        <div
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('theme.headerColor2A')"
                            class="custom-field-slider"
                        >
                            <label for="themecolor2">{{ $t("theme.headerColor2") }}</label>
                            <a-input id="themecolor2" v-model="themeColor2" class="theme-color-input" type="color" />
                            <a-slider
                                :max="100"
                                :min="0"
                                :step="5"
                                :value="themeColor2A"
                                @change="(value) => (this.themeColor2A = value)"
                            />
                        </div>
                    </a-card-grid>
                    <a-card-grid style="width: 25%; text-align: center">
                        <div
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('theme.backgroundColorA')"
                            class="custom-field-slider"
                        >
                            <label for="themecolor3">{{ $t("theme.backgroundColor") }}</label>
                            <a-input id="themecolor3" v-model="themeColor3" class="theme-color-input" type="color" />
                            <a-slider
                                :max="100"
                                :min="0"
                                :step="5"
                                :value="themeColor3A"
                                @change="(value) => (this.themeColor3A = value)"
                            />
                        </div>
                    </a-card-grid>
                    <a-card-grid style="width: 25%; text-align: center">
                        <div
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('theme.backgroundColor2A')"
                            class="custom-field-slider"
                        >
                            <label for="themecolor6">{{ $t("theme.backgroundColor2") }}</label>
                            <label>{{ $t("theme.opacity") }}</label>
                            <a-input id="themecolor6" v-model="themeColor6" class="theme-color-input" type="color" />
                            <a-slider
                                :max="100"
                                :min="0"
                                :step="5"
                                :value="themeColor6A"
                                @change="(value) => (this.themeColor6A = value)"
                            />
                        </div>
                    </a-card-grid>
                </a-card>
                <a-card v-if="preferredThemeColor === 'custom'" class="card">
                    <a-card-grid style="width: 25%; text-align: center">
                        <div>
                            <label for="themecolor5">{{ $t("theme.errorTheme") }}</label>
                            <a-input id="themecolor5" v-model="themeColor5" class="width-80" type="color" />
                        </div>
                    </a-card-grid>
                    <a-card-grid style="width: 25%; text-align: center">
                        <label class="font-size-13" for="chatBubbleBackground" v>{{
                            $t("theme.bubbleBackground")
                        }}</label>
                        <a-input
                            id="chatBubbleBackground"
                            v-model="chatBubbleBackground"
                            class="width-80"
                            type="color"
                        />
                    </a-card-grid>
                    <a-card-grid style="width: 25%; text-align: center">
                        <label class="font-size-13" for="chatBubbleVisitorBackground" v>{{
                            $t("theme.bubbleVisitorBackground")
                        }}</label>
                        <a-input
                            id="chatBubbleVisitorBackground"
                            v-model="chatBubbleVisitorBackground"
                            class="width-80"
                            type="color"
                        />
                    </a-card-grid>
                    <a-card-grid style="width: 25%; text-align: center">
                        <label for="chatBubbleText">{{ $t("theme.bubbleText") }}</label>
                        <a-input id="chatBubbleText" v-model="chatBubbleText" class="width-80" type="color" />
                    </a-card-grid>
                    <a-card-grid style="width: 25%; text-align: center">
                        <label for="chatBubbleVisitorText">{{ $t("theme.bubbleVisitorText") }}</label>
                        <a-input
                            id="chatBubbleVisitorText"
                            v-model="chatBubbleVisitorText"
                            class="width-80"
                            type="color"
                        />
                    </a-card-grid>
                    <a-card-grid style="width: 25%; text-align: center">
                        <label for="themeColor4">{{ $t("theme.textColor") }}</label>
                        <a-input id="themeColor4" v-model="themeColor4" class="width-80" type="color" />
                    </a-card-grid>
                    <a-card-grid style="width: 25%; text-align: center">
                        <label for="themeColor7">{{ $t("theme.textFormColor") }}</label>
                        <a-input id="themeColor7" v-model="themeColor7" class="width-80" type="color" />
                    </a-card-grid>
                    <a-card-grid style="width: 25%; text-align: center">
                        <a-button class="previewButton btnColor" @click="previewApp" danger ghost>
                            <font-awesome-icon v-if="previewLoading" icon="spinner" spin />
                            <span v-else>
                                {{ isPreviewActive ? $t("message.closePreviewColors") : $t("message.previewColors") }}
                            </span>
                        </a-button>
                    </a-card-grid>
                </a-card>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import log2 from "../../../../utils/log2";
import WirelessKeyboardIcon from "../../../../components/svg/icons/WirelessKeyboardIcon.vue";
import FeatureItem from "../components/FeatureItem.vue";
import CONFIG from "../../../../config/config";
import * as _ from "lodash";
import ChatThemeEditor from "../components/theme/ChatThemeEditor.vue";

const log = log2("Settings/ChatThemeSettings");

export default {
    name: "ChatThemeSettings",
    components: {
        WirelessKeyboardIcon,
        FeatureItem,
        ChatThemeEditor,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            isV2Theme: CONFIG.VERSIONV2.enabled,
            previewLoading: false,
            isPreviewActive: !!window.supsis,
            alphaMap: {
                100: "ff",
                95: "f2",
                90: "e6",
                85: "d9",
                80: "cc",
                75: "bf",
                70: "b3",
                65: "a6",
                60: "99",
                55: "8c",
                50: "80",
                45: "73",
                40: "66",
                35: "59",
                30: "4d",
                25: "40",
                20: "33",
                15: "26",
                10: "1a",
                5: "0d",
                0: "00",
            },
            alphaMapRev: {
                ff: "100",
                f2: "95",
                e6: "90",
                d9: "85",
                cc: "80",
                bf: "75",
                b3: "70",
                a6: "65",
                99: "60",
                "8c": "55",
                80: "50",
                73: "45",
                66: "40",
                59: "35",
                "4d": "30",
                40: "25",
                33: "20",
                26: "15",
                "1a": "10",
                "0d": "5",
                "00": "0",
            },
        };
    },

    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            allThemeColors: (state) => state.setting.allThemeColors,
        }),
        isVersionV2: {
            get() {
                return this.settings.chatCustomizationSettings.isVersionV2;
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.isVersionV2", value);
            },
        },
        preferredThemeColor: {
            get() {
                return _.get(this.settings.chatCustomizationSettings, "preferredThemeColor");
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.preferredThemeColor", value);
            },
        },
        themeColor1: {
            get() {
                return (this.settings.chatCustomizationSettings.themeColor1 || "#000000").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor1", value);
            },
        },
        themeColor2: {
            get() {
                return (this.settings.chatCustomizationSettings.themeColor2 || "#000000").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor2", value);
            },
        },
        themeColor3: {
            get() {
                return (this.settings.chatCustomizationSettings.themeColor3 || "#000000").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor3", value);
            },
        },
        themeColor4: {
            get() {
                return (this.settings.chatCustomizationSettings.themeColor4 || "#000000").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor4", value);
            },
        },
        themeColor5: {
            get() {
                return (this.settings.chatCustomizationSettings.themeColor5 || "#000000").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor5", value);
            },
        },
        themeColor6: {
            get() {
                return (this.settings.chatCustomizationSettings.themeColor6 || "#000000").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor6", value);
            },
        },
        themeColor7: {
            get() {
                return (this.settings.chatCustomizationSettings.themeColor7 || "#000000").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor7", value);
            },
        },
        themeColor1A: {
            get() {
                return (
                    parseInt(
                        this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor1.substr(7, 9).toLowerCase()]
                    ) || 100
                );
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor1", this.addAlpha(this.themeColor1, value));
            },
        },
        themeColor2A: {
            get() {
                return (
                    parseInt(
                        this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor2.substr(7, 9).toLowerCase()]
                    ) || 100
                );
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor2", this.addAlpha(this.themeColor2, value));
            },
        },
        themeColor3A: {
            get() {
                return (
                    parseInt(
                        this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor3.substr(7, 9).toLowerCase()]
                    ) || 100
                );
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor3", this.addAlpha(this.themeColor3, value));
            },
        },
        themeColor4A: {
            get() {
                return (
                    parseInt(
                        this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor4.substr(7, 9).toLowerCase()]
                    ) || 100
                );
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor4", this.addAlpha(this.themeColor4, value));
            },
        },
        themeColor5A: {
            get() {
                return (
                    parseInt(
                        this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor5.substr(7, 9).toLowerCase()]
                    ) || 100
                );
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor5", this.addAlpha(this.themeColor5, value));
            },
        },
        themeColor6A: {
            get() {
                return (
                    parseInt(
                        this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor6.substr(7, 9).toLowerCase()]
                    ) || 100
                );
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.themeColor6", this.addAlpha(this.themeColor6, value));
            },
        },
        chatBubbleBackground: {
            get() {
                return (this.settings.chatCustomizationSettings.chatBubbleBackground || "#ffffff").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.chatBubbleBackground", value);
            },
        },
        chatBubbleBackgroundA: {
            get() {
                return (
                    this.alphaMapRev[
                        this.settings.chatCustomizationSettings.chatBubbleBackground.substr(7, 9).toLowerCase()
                    ] || 100
                );
            },
            set(value) {
                updateSettings(
                    "chatCustomizationSettings.chatBubbleBackground",
                    this.addAlpha(this.chatBubbleBackground, value)
                );
            },
        },
        chatBubbleVisitorBackground: {
            get() {
                return (this.settings.chatCustomizationSettings.chatBubbleVisitorBackground || "#ffffff").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.chatBubbleVisitorBackground", value);
            },
        },
        chatBubbleText: {
            get() {
                return (this.settings.chatCustomizationSettings.chatBubbleText || "#000000").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.chatBubbleText", value);
            },
        },
        chatBubbleVisitorText: {
            get() {
                return (this.settings.chatCustomizationSettings.chatBubbleVisitorText || "#000000").substr(0, 7);
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.chatBubbleVisitorText", value);
            },
        },
    },
    methods: {
        readValue(id) {
            if (id === "writing") {
                return this.settings.writing == 1;
            } else {
                return this.settings[id];
            }
        },
        setValue(key, value) {
            this.updateSettings(key, value);
        },
        previewApp() {
            if (this.isPreviewActive) {
                const supsis = window.supsis;
                if (!!supsis) supsis("destroy");
                this.isPreviewActive = false;
            } else {
                this.previewLoading = true;
                window.supsis =
                    window.supsis ||
                    function () {
                        (supsis.q = supsis.q || []).push(arguments);
                    };
                window.supsis.l = +new Date();
                const supsis = window.supsis;
                supsis("ready", () => {
                    this.previewLoading = false;
                    supsis("open");
                });
                let scriptElement = document.createElement("script");
                scriptElement.setAttribute("src", this.integrationScript());
                scriptElement.setAttribute("async", "true");
                scriptElement.setAttribute("defer", "true");
                scriptElement.setAttribute("id", "previewScript");
                document.body.appendChild(scriptElement);
                this.isPreviewActive = true;
            }
        },
        addAlpha(hex, e) {
            hex = hex.substring(1).split("");
            if (hex.length === 8) {
                hex.pop();
                hex.pop();
            }
            hex = "#" + hex.join("");
            return hex + this.alphaMap[e];
        },
        integrationScript() {
            const isProduction = process.env.PRODUCTION === "true";
            const hostname = this.site.customerClientAddress;
            const protocol = isProduction ? "https" : "http";
            const path = isProduction ? "static/js/loader.js" : "loader.js";
            return `${protocol}://${hostname}/${path}`;
        },
    },
    mounted() {},
    beforeDestroy() {
        const supsis = window.supsis;
        if (!!supsis) supsis("destroy");
        this.isPreviewActive = false;
    },
    watch: {},
};
</script>

<style scoped lang="scss">
.chat-theme-settings {
    .width-80 {
        width: 80%;
    }

    .right {
        display: flex !important;
        align-items: center !important;

        .ant-switch-checked {
            background-color: var(--color-bg-primary-default);
        }
    }

    .font-size-13 {
        font-size: 13px;
    }

    .card {
        margin-top: 50px;
        width: 900px;
    }

    .btnColor {
        margin: 14px;
        border-color: var(--color-bg-primary-default) !important;
        color: var(--color-bg-primary-default) !important;
    }
}
</style>
